import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid,
  ReferenceArea, Tooltip,
} from "recharts";

/* Straight-line segments only (type="linear"): the lines are visual
   connections — intermediate values were NOT measured. No extra points,
   no smoothing. */
export default function GlucoseChart({ readings, target, unit = "mg/dL" }) {
  const data = (readings || []).map((r) => {
    const d = new Date(r.datetime);
    return {
      t: d.getTime(),
      label: d.toLocaleTimeString("pt-PT", { hour: "2-digit", minute: "2-digit" }),
      value: r.value,
      source: r.source,
    };
  });

  if (data.length === 0) {
    return (
      <div className="h-[220px] flex items-center justify-center text-[#627D98] text-sm">
        Sem leituras no período.
      </div>
    );
  }

  const values = data.map((d) => d.value);
  const lo = target ? target.lower : Math.min(...values);
  const hi = target ? target.upper : Math.max(...values);
  const yMin = Math.max(0, Math.min(Math.min(...values), lo) - 20);
  const yMax = Math.max(Math.max(...values), hi) + 20;

  return (
    <div data-testid="glucose-chart">
      <ResponsiveContainer width="100%" height={240}>
        <LineChart data={data} margin={{ top: 10, right: 12, bottom: 4, left: -8 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#EDF3F9" vertical={false} />
          {target && (
            <ReferenceArea
              y1={lo}
              y2={hi}
              fill="#E3F2FD"
              fillOpacity={0.7}
              stroke="#90CAF9"
              strokeOpacity={0.6}
            />
          )}
          <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#627D98" }} tickLine={false} axisLine={{ stroke: "#E3EFF9" }} />
          <YAxis domain={[yMin, yMax]} tick={{ fontSize: 11, fill: "#627D98" }} tickLine={false} axisLine={false} width={44} />
          <Tooltip
            contentStyle={{ borderRadius: 12, border: "1px solid #E3EFF9", fontSize: 12 }}
            formatter={(v) => [`${v} ${unit}`, "Glicemia"]}
            labelFormatter={(l, p) => {
              const src = p?.[0]?.payload?.source;
              return `${l}${src ? " · " + (src === "sensor" ? "Sensor" : "Capilar") : ""}`;
            }}
          />
          <Line
            type="linear"
            dataKey="value"
            stroke="#0D47A1"
            strokeWidth={2.5}
            dot={{ r: 4, fill: "#1E88E5", stroke: "#fff", strokeWidth: 2 }}
            activeDot={{ r: 6 }}
            isAnimationActive={true}
            connectNulls={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
